// frontend/src/api.js

const API_BASE_URL = process.env.REACT_APP_API_URL || ''; // Use env var if set, otherwise use proxy/relative path

const authHeaders = (token) => ({
    Authorization: `Bearer ${token}`,
});

export const getFaces = async (token) => {
    const response = await fetch(`${API_BASE_URL}/faces`, {
        headers: authHeaders(token),
    });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
};

export const getFace = async (id, token) => {
    const response = await fetch(`${API_BASE_URL}/faces/${id}`, {
        headers: authHeaders(token),
    });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
};

export const createFace = async (formData, token) => {
    // formData should contain 'image' File and other fields
    const response = await fetch(`${API_BASE_URL}/faces`, {
        method: 'POST',
        headers: authHeaders(token),
        body: formData, // FormData handles Content-Type automatically
    });
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.error}`);
    }
    return await response.json();
};

export const updateFace = async (id, data, token) => {
    const response = await fetch(`${API_BASE_URL}/faces/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            ...authHeaders(token),
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.error}`);
    }
    return await response.json();
};

export const deleteFace = async (id, token) => {
    const response = await fetch(`${API_BASE_URL}/faces/${id}`, {
        method: 'DELETE',
        headers: authHeaders(token),
    });
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.error}`);
    }
    return await response.json();
};

export const addMeeting = async (faceId, meetingData, token) => {
    const response = await fetch(`${API_BASE_URL}/faces/${faceId}/meetings`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeaders(token),
        },
        body: JSON.stringify(meetingData),
    });
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.error}`);
    }
    return await response.json();
};

export const updateMeeting = async (meetingId, meetingData, token) => {
    const response = await fetch(`${API_BASE_URL}/meetings/${meetingId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            ...authHeaders(token),
        },
        body: JSON.stringify(meetingData),
    });
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.error}`);
    }
    return await response.json();
};

export const deleteMeeting = async (meetingId, token) => {
    const response = await fetch(`${API_BASE_URL}/meetings/${meetingId}`, {
        method: 'DELETE',
        headers: authHeaders(token),
    });
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.error}`);
    }
    return await response.json();
};
